import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiHome,
  FiUsers,
  FiLogOut,
  FiMenu,
  FiX,
  FiUpload,
  FiCpu,
  FiMessageSquare,
} from "react-icons/fi";
import { MdOutlineCheckCircle } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { trackLogout } from "../../utils/clickTracking";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem('user')) || { role: 'supervisor' };

  const handleLogout = async () => {
    try {
      if (user?.id) {
        await trackLogout(user.id, user.role);
      }
    } catch (err) {
      console.error('Error tracking logout:', err);
    } finally {
      localStorage.clear();
      window.location.href = "/login";
    }
  };

  const linkClasses = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-300 group ${
      isActive
        ? "bg-green-700 text-white shadow-lg transform scale-105"
        : "text-green-800 hover:bg-green-800/10 hover:text-green-700"
    }`;

  return (
    <header className="w-full bg-white/90 shadow-md backdrop-blur-md sticky top-0 z-50 border-b border-green-100">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 py-3">
        {/* Logo + Title */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center shadow-sm">
            <FiUsers className="text-green-700 text-xl" />
          </div>
          <div className="flex flex-col">
            <div className="text-lg sm:text-xl font-bold text-green-800">
              Supervisor Dashboard
            </div>
            <div className="text-xs sm:text-sm text-green-700/70 font-medium">
              Property Management System
            </div>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-1 bg-white/30 backdrop-blur-md rounded-2xl p-1 border border-green-100">
          <NavLink to="/supervisor" end className={linkClasses}>
            <FiHome className="text-base" />
            <span>Dashboard</span>
          </NavLink>

          <NavLink to="/supervisor/property" className={linkClasses}>
            <FiUsers className="text-base" />
            <span>Properties</span>
          </NavLink>

          <NavLink to="/supervisor/flaged" className={linkClasses}>
            <HiOutlineExclamationCircle className="text-base" />
            <span>Flagged</span>
          </NavLink>

          <NavLink to="/supervisor/flagged-by-ai" className={linkClasses}>
            <FiCpu className="text-base" />
            <span>Computer Vision</span>
          </NavLink>

         <NavLink to="/supervisor/resolved" className={linkClasses}>
            <MdOutlineCheckCircle className="text-base" />
            <span>Resolved</span>
          </NavLink>

          <NavLink to="/supervisor/not-resolved" className={linkClasses}>
            <HiOutlineExclamationCircle className="text-base" />
            <span>Not Resolved</span>
          </NavLink>

          {/* ── NEW: My Uploads ── */}
          {/* <NavLink to="/supervisor/my-uploads" className={linkClasses}>
            <FiUpload className="text-base" />
            <span>My Uploads</span>
          </NavLink> */}
        </nav>

        {/* Right side: Logout */}
        <div className="hidden lg:flex items-center">
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 bg-green-700 text-white px-5 py-2 rounded-xl font-semibold text-sm shadow-md hover:bg-green-600 active:scale-95 transition-all duration-300"
          >
            <FiLogOut className="text-base" />
            Logout
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="lg:hidden text-green-800 text-2xl p-2 rounded-lg hover:bg-green-50 active:scale-95 transition-all"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Dropdown */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ${
            menuOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="bg-green-50 border-t border-green-100 px-4 py-4 space-y-2 shadow-inner">
            <NavLink to="/supervisor" end className={linkClasses} onClick={() => setMenuOpen(false)}>
              <FiHome className="text-base" />
              <span>Dashboard</span>
            </NavLink>

            <NavLink to="/supervisor/property" className={linkClasses} onClick={() => setMenuOpen(false)}>
              <FiUsers className="text-base" />
              <span>Properties</span>
            </NavLink>

            <NavLink to="/supervisor/flaged" className={linkClasses} onClick={() => setMenuOpen(false)}>
              <HiOutlineExclamationCircle className="text-base" />
              <span>Flagged</span>
            </NavLink>

            <NavLink to="/supervisor/flagged-by-ai" className={linkClasses} onClick={() => setMenuOpen(false)}>
              <FiCpu className="text-base" />
              <span>Flagged by AI</span>
            </NavLink>

            <NavLink to="/supervisor/resolved" className={linkClasses} onClick={() => setMenuOpen(false)}>
              <MdOutlineCheckCircle className="text-base" />
              <span>Resolved</span>
            </NavLink>

            <NavLink to="/supervisor/not-resolved" className={linkClasses} onClick={() => setMenuOpen(false)}>
              <HiOutlineExclamationCircle className="text-base" />
              <span>Not Resolved</span>
            </NavLink>
            {/* ── NEW: My Uploads ── */}
            {/* <NavLink to="/supervisor/my-uploads" className={linkClasses} onClick={() => setMenuOpen(false)}>
              <FiUpload className="text-base" />
              <span>My Uploads</span>
            </NavLink> */}

            {/* Logout */}
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 bg-green-700 text-white px-4 py-3 rounded-xl font-semibold text-sm shadow-md hover:bg-green-600 transition-all duration-300"
            >
              <FiLogOut className="text-base" />
              Logout
            </button>
          </div>
        </div>
    </header>
  );
};

export default Header;
